import { useCallback } from "react"
import { RecoilState, useSetRecoilState } from "recoil"

export const useIncrementRecoilState = (state: RecoilState<number>) => {
  const set = useSetRecoilState(state)
  return useCallback(() => set((n) => n + 1), [set])
}
